import clsx from "clsx";
import { AuthContext } from "context/AuthContext";
import { fetchWithParams } from "lib/fetcher";
import PubSub from "pubsub-js";
import { SvgArrowDown, SvgPosition, SvgCalendar, SvgCamera } from "ui/svgs";
import { useContext, useState, useEffect } from "react";
import { showToast } from "ui/components/common";
import { Modal } from "antd";
import { StreamingCameraType } from "lib/types";
import { Popover } from "react-tiny-popover";
import { formatMinute } from "lib/utils";
import TimePick from "ui/components/timepick";
import useSWR from "swr";
import NvrItem from "ui/playback/nvr-item";
import { SignalContext } from "context/SignalContext";
import { v4 as uuidv4 } from "uuid";
import { ActRequestType } from "webrtc-player/common/base";
import moment from "moment";
export const DownloadModalStyles = {
  content: {
    zIndex: 1000,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    borderRadius: "16px",
    borderWidth: "0px",
    padding: "24px",
  },
};
const defaultInterval = 2 * 60 * 1000;
export default function DownloadModal({
  modalOpen,
  setModalOpen,
  startAt,
  streamingCameraPlayback,
}: {
  modalOpen: boolean;
  setModalOpen: (isOpen: boolean) => void;
  startAt: number;
  streamingCameraPlayback: StreamingCameraType;
}) {
  const { user } = useContext(AuthContext);
  const { signal, wsIsOpen, wsMsgData } = useContext(SignalContext);

  const [streamId, setStreamId] = useState(0);
  const [isSTimePopoverOpen, setIsSTimePopoverOpen] = useState(false);
  const [isETimePopoverOpen, setIsETimePopoverOpen] = useState(false);
  const [selectedCameras, setSelectedCameras] = useState<
    { cameraId: number; name: string }[]
  >([]);
  const [nvrInitalErrors, setNvrInitalErrors] = useState<
    { nvrId: number; error: string }[]
  >([]);
  const [cameraInitalErrors, setCameraInitalErrors] = useState<
    { cameraId: number; error: string }[]
  >([]);
  const [initialSuccessCameraIds, setInitialSuccessCameraIds] = useState<
    string[]
  >([]);
  const [downloadloading, setDownloadloading] = useState(false);
  const [downloaderId, setDownloaderId] = useState("");
  const [wsInitialRequestId, setWsInitialRequestId] = useState("");
  const [wsInitialRequests, setWsInitialRequests] = useState([]);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const params = `?siteId=${streamingCameraPlayback.siteId}&page.limit=100`;
  const { data } = useSWR(
    [`/device/nvrs${params}`, user.token, user.orgId],
    ([url, token, orgId]) => fetchWithParams(url, token, orgId),
    {
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    if (modalOpen) {
      return;
    }
    const date = new Date(startAt * 1000);
    date.setSeconds(0);
    setStartTime(date.getTime());
    setEndTime(date.getTime() + defaultInterval / 2);
  }, [startAt, modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      setNvrInitalErrors([]);
      setCameraInitalErrors([]);
      setInitialSuccessCameraIds([]);
      setSelectedCameras([
        {
          cameraId: +streamingCameraPlayback?.cameraId,
          name: streamingCameraPlayback?.cameraName,
        },
      ]);
    }
  }, [modalOpen]);

  useEffect(() => {
    if (
      !wsMsgData ||
      !wsMsgData.result ||
      wsMsgData.result.id !== wsInitialRequestId
    ) {
      return;
    }
    //new tasks
    let tasks = [];
    const succeedTasks = [];
    tasks = [...wsInitialRequests].map((item) => {
      item.state = "generating";
      item.chunk = -1;
      return item;
    });
    setDownloadloading(false);
    if (
      wsMsgData.result.error ||
      !wsMsgData?.result?.data ||
      !wsMsgData.result.data.deviceDownloaderInitiateReply
    ) {
      showToast(
        1,
        "There was a problem initailing the downloads. Please try again.",
      );
      return;
    }
    const nvrErrors: { nvrId: number; error: string }[] = [];
    const cameraErrors: { cameraId: number; error: string }[] = [];
    const cameraSuccessIds: string[] = [];
    wsMsgData.result.data.deviceDownloaderInitiateReply.result?.forEach(
      (result) => {
        if (result.error) {
          nvrErrors.push({ nvrId: +result.nvrId, error: result.error.name });
          return;
        }
        result.responses?.forEach((response) => {
          if (response.error) {
            cameraErrors.push({
              cameraId: +response.camera.id,
              error: response.error.name,
            });
          } else {
            // Uncheck camera
            cameraSuccessIds.push(response.camera.id);
            //complete camera params
            tasks.forEach((item) => {
              if (item.camera.id === response.camera.id) {
                item.orgId = user.orgId;
                item.nvrId = result.nvrId;
                item.camera.macAddress = response.camera.macAddress || "";
                item.camera.remoteIndex = response.camera.remoteIndex || 0;
                item.progress = 0;
                succeedTasks.push(item);
              }
            });
          }
        });
      },
    );
    cameraSuccessIds.forEach((cameraId) => {
      // Uncheck camera
      setSelectedCameras((prev) =>
        prev.filter((camera) => camera.cameraId !== +cameraId),
      );
    });
    setInitialSuccessCameraIds(cameraSuccessIds);
    setNvrInitalErrors(nvrErrors);
    setCameraInitalErrors(cameraErrors);
    setWsInitialRequestId("");
    PubSub.publish("addDownloadTask", succeedTasks);
    if (nvrErrors.length === 0 && cameraErrors.length === 0) {
      showToast(0, "Downloads have been initailed.", { minWidth: 300 });
      setModalOpen(false);
      //merge old tasks

      // let downloadedRecords = getLocalStroageByKeyId("downloadedRecords", user.id) || [];
      // appenToLocalStroageByKeyId('downloadedRecords',user.id,[...tasks,...downloadedRecords])
    }
  }, [wsMsgData]);

  const downloadInitail = () => {
    if (!signal || !wsIsOpen) {
      console.error("Websocket is not open");
      return;
    }
    let newDownloaderId = downloaderId;
    if (!newDownloaderId) {
      const downloaderId = localStorage.getItem("downloaderId");
      if (!downloaderId) {
        newDownloaderId = uuidv4();
        localStorage.setItem("downloaderId", JSON.stringify(downloaderId));
      } else {
        newDownloaderId = downloaderId;
      }
      setDownloaderId(newDownloaderId);
    }
    const requestId = uuidv4();
    const requests = [];

    selectedCameras?.forEach((camera) => {
      const recordName =
        camera.name +
        "_" +
        moment(startTime).format("YY_MMDD_HHmm") +
        "-" +
        moment(endTime).format("HHmm");
      requests.push({
        actorId: user.id.toString(),
        downloaderId: newDownloaderId,
        recordId: uuidv4(),
        camera: {
          id: camera.cameraId,
        },
        record: {
          startAt: startTime / 1000,
          endAt: endTime / 1000,
          streamId: streamId,
          name: recordName,
          speed: 8,
        },
      });
    });

    //Signal Send Message to get Playback Records
    const message: ActRequestType = {
      request: {
        id: requestId,
        act: "device.downloader.initiate",
        data: {
          deviceDownloaderInitiate: {
            requests: requests,
          },
        },
      },
      headers: { orgId: user.orgId },
    };

    console.log("sending message = ", message);
    setDownloadloading(true);
    setWsInitialRequestId(requestId);
    setWsInitialRequests(requests);
    signal.sendMessage(message);
  };

  return (
    <Modal
      open={modalOpen}
      width={600}
      onCancel={() => setModalOpen(false)}
      footer={false}
      destroyOnClose={true}
    >
      <h1 className="text-xl font-bold">Download</h1>
      <div className="p-4 bg-zinc-100 rounded-2xl mt-4 flex justify-between fill-neutral-500 text-neutral-800">
        <span className="flex items-center gap-2">
          <SvgPosition width="14" className="flex-shrink-0" />
          {streamingCameraPlayback?.siteName}
        </span>
        <span className="flex items-center gap-1">
          <SvgCamera width="18" className="flex-shrink-0" />
          {streamingCameraPlayback?.cameraName}
        </span>
        <span className="flex items-center gap-2">
          <SvgCalendar width="14" className="flex-shrink-0" />
          {moment(startAt * 1000).format("MMM DD, YYYY [at] HH:mm A")}
        </span>
      </div>
      <div className="font-semibold mt-4">
        Up to total 60 minutes can be downloaded at the same time.
      </div>
      <div className="mt-4 flex items-center h-10 font-semibold ">
        <span
          className={clsx(
            "flex h-full w-24 items-center justify-center border border-zinc-200 hover:opacity-80 rounded-s-full cursor-pointer",
            streamId === 0 ? "bg-blue-100 gap-1.5" : "white",
          )}
          onClick={() => {
            setStreamId(0);
          }}
        >
          HD
        </span>
        <span
          className={clsx(
            "flex h-full w-24 items-center justify-center border border-zinc-200 hover:opacity-80 rounded-e-full cursor-pointer",
            streamId === 1 ? "bg-blue-100 gap-1.5" : "white",
          )}
          onClick={() => {
            setStreamId(1);
          }}
        >
          SD
        </span>
      </div>
      <div className="w-full mt-4">
        <div className="w-full flex pr-5">
          <span className="flex-grow">Start Time</span>
          <span className="flex-grow">End Time</span>
        </div>
        <div className="w-full flex mt-2 gap-4 items-center">
          <span className="flex-grow">
            <Popover
              align="start"
              isOpen={isSTimePopoverOpen}
              positions={["bottom", "right", "left", "top"]} // preferred positions by priority
              onClickOutside={() => setIsSTimePopoverOpen(false)} // handle click events outside of the popover/target here!
              content={
                <div className="border rounded-xl z-[1201]">
                  <TimePick
                    curDateTime={new Date(startTime)}
                    onChange={(date) => {
                      const startTime = date.getTime();
                      console.log("startTime", startTime);
                      setStartTime(startTime);
                    }}
                    minuteInterval={1}
                  />
                </div>
              }
            >
              <div className="h-9 flex items-center ">
                <button
                  className="flex flex-grow items-center justify-between rounded-2xl hover:border-blue-500 border border-neutral-400 px-5  h-full"
                  onClick={() => setIsSTimePopoverOpen(!isSTimePopoverOpen)}
                >
                  <p className="text-sm">{formatMinute(startTime)}</p>
                  <SvgArrowDown width="12" className="fill-neutral-400" />
                </button>
              </div>
            </Popover>
          </span>
          <span className="flex-grow">
            <Popover
              align="start"
              isOpen={isETimePopoverOpen}
              positions={["bottom", "right", "left", "top"]}
              onClickOutside={() => setIsETimePopoverOpen(!isETimePopoverOpen)}
              content={
                <div className="border rounded-xl  z-[1201]">
                  <TimePick
                    curDateTime={new Date(endTime)}
                    onChange={(date) => {
                      const endTime = date.getTime();
                      // endTime > 24 * 60 * 60 * 1000 && (endTime = endTime - 24 * 60 * 60);
                      //endTime == 0 && (endTime = 24 * 60 * 60);
                      setEndTime(endTime);
                    }}
                    minuteInterval={1}
                  />
                </div>
              }
            >
              <div className="h-9 flex items-center ">
                <button
                  className={clsx(
                    "flex flex-grow items-center justify-between rounded-2xl hover:border-blue-500 border border-neutral-400 px-5 h-full",
                  )}
                  onClick={() => setIsETimePopoverOpen(!isETimePopoverOpen)}
                >
                  <p className="text-sm">{formatMinute(endTime)}</p>
                  <SvgArrowDown width="12" className="fill-neutral-400" />
                </button>
              </div>
            </Popover>
          </span>
        </div>
        {endTime <= startTime ? (
          <div className="text-sm text-red-500 font-semibold mt-1 ml-1">
            End time cannot be earlier than start time!
          </div>
        ) : endTime > startTime + 60 * 60 * 1000 ? (
          <div className="text-sm text-red-500 font-semibold mt-1 ml-1">
            No more than 60 minutes!
          </div>
        ) : (
          <div className="h-6" />
        )}
      </div>
      <div className="max-h-96 overflow-y-auto">
        {data &&
          data.data &&
          data.page.total > 0 &&
          data.data.map((data: any) => (
            <NvrItem
              siteId={streamingCameraPlayback.siteId}
              objData={data}
              defaultNvrId={+streamingCameraPlayback.nvrId}
              key={data.id}
              selectedCameras={selectedCameras}
              setSelectedCameras={setSelectedCameras}
              nvrInitalErrors={nvrInitalErrors}
              cameraInitalErrors={cameraInitalErrors}
              initialSuccessCameraIds={initialSuccessCameraIds}
            />
          ))}
      </div>
      <div className="flex items-center justify-end mt-6">
        <button
          className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
          onClick={() => {
            setModalOpen(false);
          }}
        >
          Cancel
        </button>
        <button
          disabled={
            selectedCameras.length === 0 ||
            endTime <= startTime ||
            downloadloading ||
            endTime > startTime + 60 * 60 * 1000
          }
          className="ml-4 rounded-2xl flex justify-center items-center w-[113px] h-[52px] bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50  disabled:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={() => {
            downloadInitail();
          }}
        >
          {downloadloading ? (
            <div
              className="ml-1 text-white inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
          ) : (
            "Download"
          )}
        </button>
      </div>
    </Modal>
  );
}
